/* eslint-disable no-console */
import {
  BehaviorSubject,
  catchError,
  EMPTY,
  filter,
  first,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthFacade } from './+state/auth.facade';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null,
  );

  constructor(
    private authService: AuthService,
    private authfacade: AuthFacade,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return this.authService.accessToken$.pipe(
      first(),
      switchMap((token) => {
        if (
          !token ||
          request.url.indexOf('/api/') < 0 ||
          request.url.indexOf('/api/auth/refresh') !== -1 ||
          request.url.indexOf('/api/auth/azure-sign-in') !== -1
        ) {
          return next.handle(request);
        }

        request = this.addTokenHeader(request, token);

        return next.handle(request).pipe(
          catchError((error) => {
            if (
              error instanceof HttpErrorResponse &&
              !request.url.includes('auth/signin') &&
              error.status === 401
            ) {
              console.log(
                'Auth interceptor - intercepting 401 error on ' + request.url,
              );

              return this.handle401Error(request, next);
            }

            return throwError(() => error);
          }),
        );
      }),
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      //this.authService.refreshTokens;

      return this.authService.refreshTokens().pipe(
        switchMap((result) => {
          this.isRefreshing = false;
          if (!result) {
            throw new Error('Impossibile ripristinare la sessione. ');
          }
          console.log('Refresh token completed - retrying ' + request.url);
          this.refreshTokenSubject.next(result.accessToken);
          return next.handle(this.addTokenHeader(request, result.accessToken));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.authfacade.sessionExpired();
          return EMPTY;
        }),
      );
    }

    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token))),
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    /* for Spring Boot back-end */
    // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });

    /* for Node.js Express back-end */
    return request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + token),
    });
  }
}
